<template>
  <div class="row">
    <!--  导师咨询列表  -->
    <div class="flex xs12">
      <va-card title="导师咨询">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="topic"
              placeholder="搜索咨询话题"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <!--    导师uid筛选      -->
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="mentorUid"
              placeholder="搜索导师ID"
              @input="searchMentorUid"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
        </div>
        <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
        <va-data-table
          :fields="fields"
          :data="consultings"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listConsulting"
          api-mode
        >
          <!-- 导师名字 -->
          <template slot="mentorName" slot-scope="props">
            <va-button flat small :to='{path:`/admin/mentors/getMentor/${props.rowData.mentorUid}`}'>
              {{ props.rowData.mentorBasicInfo.nickname }}
            </va-button>
          </template>
          <!--  排序  -->
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
              oninput="if(value<0)value=1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                :to='{path:`updateConsulting/${props.rowData.uid}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true; deleteUid=props.rowData.uid"/>
            </va-popover>
            <va-popover message="查看报名统计" placement="top">
              <va-button flat small color="gray" icon="vuestic-iconset vuestic-iconset-statistics va-icon vuestic-iconset vuestic-iconset-statistics"
                :to='{path: `/admin/applications/listAppliedConsulting`, query:{consultingUid: props.rowData.uid }}'/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除导师咨询"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import consultingApi from '../../api/consulting'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      consultings: [],
      topic: '',
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 1,
      deleteModal: false,
      deleteUid: null,
      mentorUid: this.$route.query.mentorUid,
      mentorOptions: [],
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:sort',
          title: '排序',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:mentorName',
          title: '导师',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'topic',
          title: '咨询话题',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listConsulting()
  },
  methods: {
    listConsulting (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        status: 1,
        topic: this.topic,
        mentorUid: this.mentorUid ? this.mentorUid : null,
      }
      consultingApi.listConsulting(params).then(response => {
        this.consultings = response.consultings
        this.consultings.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error))
    },
    confirmDelete () {
      if (this.deleteUid === null) return
      consultingApi.deleteConsulting(this.deleteUid).then(response => {
        if (response.success === true) {
          this.showToast('删除咨询成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
          this.listConsulting()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    search: debounce(function (topic) {
      this.topic = topic
      this.listConsulting()
    }, 400),
    searchMentorUid: debounce(function (mentorUid) {
      this.mentorUid = mentorUid
      this.listConsulting()
    }, 400),
    updateSortNum: function (params) {
      const data = {
        sortNum: params.sortNum,
      }
      consultingApi.updateConsulting(params.uid, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listConsulting()
        }
      }).catch(error => alert(error))
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
